<div class="tab-section">
  <!-- <div *ngIf='installedData.length > 0'> -->
  <div class="dropdown-select">
    <div class="d-flex">
        <p class="textBlueBold mr-10">Division : </p>
      <p-dropdown
        [options]="dropDownData"
        [(ngModel)]="selectedDivision"
        optionLabel="label"
        optionValue="value"
        styleClass="ml-10 ht-35"
        [autoDisplayFirst]="true"
        (onChange)="onDivisionChange()"
      >
      </p-dropdown>
    </div>
  </div>
  
  <div class="mt-10">
    <p-table
      [value]="filterdInstalledData"
      [scrollable]="true" id="StyleTable" scrollHeight="400px"
      
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Division</th>
          <th>Section</th>
          <th >TLR#</th>
          <th >TLR Status</th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.division_name }}</td>
          <td>{{ row.section_name }}</td>
          <td [ngClass]="row.cssClass">{{ row.tag_number }}</td>
          <td [ngClass]="row.cssClass">{{ row.status }}</td>
          <td><a (click)="details(row)" class="link-underline">Details</a></td>
          <td><a (click)="assignToMe(row)" class="link-underline">Assign</a></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <!-- </div> -->
  <!-- <div *ngIf="installedData.length == 0">
    <p class="messageTitle">There are no TLR's that have been OA (Installed)</p>
</div> -->
</div>
